import { TicketSolvedStatusEnum } from "../../api-client";

const statusHelper = {
    getSolvedStatus: function (solvedInDays?: number, resolutionDays?: number) {
        if(solvedInDays && solvedInDays > (resolutionDays ?? 1)) {
            return TicketSolvedStatusEnum.Delay;
        }

        return TicketSolvedStatusEnum.Ontime;
    },
    getSolvedStatusIcon: function (status: string) {
        switch (status) {
            case TicketSolvedStatusEnum.Ontime: return "ReminderTime";
            case TicketSolvedStatusEnum.Delay: return "ShieldAlert";
            case TicketSolvedStatusEnum.Inprogress: return "ProgressRingDots";

            default: return "ShieldAlert";
        }
    },
}

export default statusHelper;